<div class="d-flex pt-2"><div ngbDropdown placement="bottom-right" 
    class="kt-header__topbar-item kt-header__topbar-item--user">
    <div ngbDropdownToggle class="kt-header__topbar-wrapper">
        <div class="kt-header__topbar-user" [ngClass]="{'kt-header__topbar-icon': icon}">
            <span class="kt-header__topbar-welcome kt-hidden-mobile" *ngIf="greeting">Hi,</span>
            <span class="kt-header__topbar-username kt-hidden-mobile" *ngIf="greeting">
                {{userInfo.user.firstName | titlecase }}
            </span>
            <i *ngIf="icon" class="fa fa-user fa-lg"></i>
            <span  class="kt-badge kt-badge--username kt-badge--unified-info kt-badge--lg kt-badge--rounded kt-badge--bold bg-white">
                {{userInfo.user.firstName[0] | titlecase }}
                {{userInfo.user.lastName[0] | titlecase }}
            </span>
        </div>
    </div>
    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
        
        <div class="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x">   
       
            <!-- <div class="kt-user-card__avatar">
                <span 
                    class="kt-badge kt-badge--username kt-badge--unified-metal kt-badge--lg kt-badge--rounded kt-badge--bold text-primary bg-white-custom">
                    {{userShortName() | titlecase}}
                </span>
            </div> -->
            <!-- <ng-container *ngIf="UserImage; else NoImg">
                <a href="{{UserImage}}" target="new">
                  <img class="ImgWidth m-2" [src]="UserImage" alt="Profile User Image"/>
                </a>
            </ng-container>
            <ng-template #NoImg>
                <a href="javascript:" target="new">
                  <img class="ImgWidth img-border m-2" src="../../../../../../assets//media/logos/profile-image2.png"  alt="No Image" />
                </a>
            </ng-template> -->
       
            <a href="javascript:" target="new">
                <img class="ImgWidth img-border m-2" src="../../../../../../assets//media/logos/profile-image2.png"  alt="No Image" />
              </a>
            <div class="kt-user-card__name">
                {{userInfo.user.firstName}} 
                <div>
                    <p>{{userInfo.user.userType}}</p>
                </div>
            </div>
           
        </div>

        <div class="kt-notification">
            <a href="javascript:;" (click)="EditAccount()" class="kt-notification__item">
                <div class="kt-notification__item-icon">
                    <i class="fa fa-user-tie"></i>
                </div>
                <div class="kt-notification__item-details">
                    <div class="kt-notification__item-title kt-font-bold">
                        Edit My Profile
                    </div>
                </div>
                <span class="fa fa-arrow-right"></span>
            </a>
            <a href="javascript:;" (click)="logout()" class="kt-notification__item">
                <div class="kt-notification__item-icon">
                    <i class="fa fa-sign-out-alt"></i>
                </div>
                <div class="kt-notification__item-details">
                    <div class="kt-notification__item-title kt-font-bold">
                      Sign Out
                    </div>
                </div>
                <span class="fa fa-arrow-right"></span>
            </a>
        </div>
     
    </div>
</div>



<div ngbDropdown #myDrop="ngbDropdown" placement="bottom-right" 
    class="kt-header__topbar-item kt-header__topbar-item--user">
    <div ngbDropdownToggle class="kt-header__topbar-wrapper">
        <div class="kt-header__topbar-user" [ngClass]="{'kt-header__topbar-icon': icon}">
            <span class="material-icons yellow-color">language </span> 
        </div>
    </div>
    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
        


        <div class="kt-notification">
            <a  href="javascript:;"  (click)="changeLanguage('en');myDrop.close()" class="kt-notification__item"  [ngStyle]="{'background':currentLanguage=='en'?'rgba(50, 135, 168, 0.06)':''}">
                
                <div  class="kt-notification__item-details">
                    <div  class="kt-notification__item-title kt-font-bold">
                       English
                    </div>
                </div>
           
            </a>
            <a  href="javascript:;" (click)="changeLanguage('ar');myDrop.close()" class="kt-notification__item"  [ngStyle]="{'background':currentLanguage=='ar'?'rgba(50, 135, 168, 0.06)':''}">
               
                <div  class="kt-notification__item-details">
                    <div  class="kt-notification__item-title kt-font-bold">
                     Arabic
                    </div>
                </div>
             
            </a>
        </div>
     
    </div>
</div>
</div>